import { ButtonBarControl, ButtonBarPortal, ButtonBarRoot } from './ButtonBar';

export const ButtonBar = {
  Root: ButtonBarRoot,
  Control: ButtonBarControl,
  Portal: ButtonBarPortal,
};
